import { makeStyles } from '@material-ui/core/styles';

export  const useStyles = makeStyles(theme => ({
    formControl:{
        
        minWidth: 300,
        marginTop:'1%',
        paddingRight: theme.spacing(2),
    },
}));
